import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiFileText, FiChevronRight } from 'react-icons/fi';

const Certificates = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const certificatesList = [
    "अतिक्रमण नोटीस",
    "उत्पन्नाचा दाखला",
    "घराचे बांधकाम दुरुस्ती परवानगी",
    "थकबाकी नसल्याचा दाखला",
    "दारिद्र्य रेषेखालील दाखला",
    "नळ जोडणी अर्ज",
    "ना हरकत दाखला",
    "बांधकाम परवानगी अर्ज यादी",
    "रहिवासी दाखला",
    "लाभ न घेतल्याचा दाखला",
    "विज बिल दाखला"
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">दाखला व परवाने</h1>
            <p className="text-white/80">
               {grampanchayatName ? `${grampanchayatName} | ` : ''} 
               {arthikVarshLabel ? `आर्थिक वर्ष: ${arthikVarshLabel}` : ''}
            </p>
          </div>
          <button 
           onClick={() => navigate('/asthapan-dashboard', { state: location.state })}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm"
          >
            मागे जा
          </button>
        </div>
      </div>

      {/* Certificates Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {certificatesList.map((cert, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 border-l-4 border-[#267c77] cursor-pointer group flex items-center justify-between"
            onClick={() => {
              if (cert === "अतिक्रमण नोटीस") {
                navigate('/asthapan/certificates/atikraman-notice', { state: location.state });
              } else if (cert === "उत्पन्नाचा दाखला") {
                navigate('/asthapan/certificates/income-certificate', { state: location.state });
              } else if (cert === "घराचे बांधकाम दुरुस्ती परवानगी") {
                navigate('/asthapan/certificates/construction-permission', { state: location.state });
              } else if (cert === "थकबाकी नसल्याचा दाखला") {
                navigate('/asthapan/certificates/no-dues-certificate', { state: location.state });
              } else if (cert === "दारिद्र्य रेषेखालील दाखला") {
                navigate('/asthapan/certificates/bpl-certificate', { state: location.state });
              } else if (cert === "नळ जोडणी अर्ज") {
                navigate('/asthapan/certificates/water-connection', { state: location.state });
              } else if (cert === "ना हरकत दाखला") {
                navigate('/asthapan/certificates/no-objection-certificate', { state: location.state });
              } else if (cert === "बांधकाम परवानगी अर्ज यादी") {
                navigate('/asthapan/certificates/construction-permission-app', { state: location.state });
              } else if (cert === "रहिवासी दाखला") {
                navigate('/asthapan/certificates/resident-certificate', { state: location.state });
              } else if (cert === "लाभ न घेतल्याचा दाखला") {
                navigate('/asthapan/certificates/benefit-not-availed', { state: location.state });
              } else if (cert === "विज बिल दाखला") {
                navigate('/asthapan/certificates/electricity-certificate', { state: location.state });
              } else {
                console.log(`Selected: ${cert}`);
              }
            }}
          >
             <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#267c77]/10 flex items-center justify-center text-[#267c77] group-hover:bg-[#267c77] group-hover:text-white transition-colors duration-300">
                    <FiFileText className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-[#267c77] transition-colors">
                {cert}
                </h3>
             </div>
             <FiChevronRight className="text-gray-400 group-hover:text-[#267c77] transform group-hover:translate-x-1 transition-all" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;
